import React from 'react';
import {Helmet} from 'react-helmet';
import { store } from '../../../store';

import Tasknav from '../Tasknav'

import Save from '../Save'

import AboutSection from '../Sections/About/AboutSection'

import Profile from '../Sections/Profile/Profile'

import CustomizationPanel from '../Sections/Customization/CustomizationPanel'

import Controller from '../Sections/Customization/Controller'

import LinksFunction from '../Sections/SocialLinks/LinksFunction'
import LinksSection from '../Sections/SocialLinks/LinksSection'

import ImageUploadFunction from '../Sections/Images/ImageUploadFunction'
import {ProPic, CoverImageURL} from '../Sections/Images/ImageSection'

import Menu from '../../Navigation/Menu'

const Third = ({onUser, onEdit, onOpen, onRouteChange, onWebsitename, onWebsiteBio, onCustomization, onSelectToolbar, onHighlight, onMenu, highlight, menu, handleOffClick, onClickInside, onClickOutside, onController, controller, profile_name, profile_bio, about, icons, background,onOuterDiv,onInnerDiv, outerdiv}) => {

  return ( 
<div id="scroll" className="editSection">          
<Helmet>
<meta name="viewport" content="width=device-width,initial-scale=1" />
<link href="https://fonts.googleapis.com/css?family=Coiny:400,700,700i|Dancing+Script:400,700,700i|Indie+Flower:400,700,700i|Lato:400,700,700i|Lobster+Two|Merriweather:400,700,700i|Open+Sans:400,700,700i|Pacifico:400,700,700i|Righteous:400,700,700i|Shadows+Into+Light+Two|Lora:400,700|Vibur:400,700,700i|Oswald:400,700|Roboto+Mono:400,700|Roboto:400,700,900|Abel" rel="stylesheet" />
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
<style type="text/css">{`
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
body{
  animation: .5s ease-in-out 0s 1 fadeIn;
  margin:0;
  padding: 0;
  max-width: 100%;
  overflow-x: hidden;
  background: ${background.color};
}
body::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}
body::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius:3px;
}
.bg {
  width: 100vw;
  background: ${background.color};
  min-height: 100%;
}
.wrap {
  width:100%;
  margin:0;
  padding: 0;
}
.cover {
  width:100vw;
  background:url(${CoverImageURL()});
  height: 100%;
  background-attachment: fixed;
  background-position:center;
  background-size:cover;
  opacity: ${background.opacity};
  position:fixed;
}

.main {
  width: 100%;
  display:flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
  margin:0 auto;
}
.about {
  padding:0 2em;
  z-index:1;
  min-width:40%;
  max-width: 100%;
  font-family: ${about.font};
  color:${about.color};
  font-size:${about.size}px;
  text-align:center;
}
.paragraph,
p {
  font-family: ${about.font};
  color:${about.color};
  margin-bottom:1em;
  font-size:${about.size}px;
  line-height:1.8;
}
p a {
  text-decoration:underline;
  color:${about.color};
}
p a:hover {
  text-decoration:underline;
  color:${about.color};
}

.profile-card {
  animation: 1s ease-in-out 0s 1 fadeIn;
  background: transparent;
  margin:0 auto;
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.profile {
  padding: 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  z-index: 1;
  justify-content: center;
}
.profile_pic {
  min-width:200px;
  width: 100%;
  height: 50vh;
  border-radius: 0px;
  overflow:hidden;
  margin-bottom:1em;
}
.dp {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition:.25s;
}
.profile_name {
  font-family:${profile_name.font};
  font-weight: 700;
  text-transform: capitalize;
  font-size:${profile_name.size}px;
  display: block;
  color:${profile_name.color};
  text-align:center;
  margin:0 auto;
}
.profile_desc {
  font-family:${profile_bio.font};
  color:${profile_bio.color};
  font-size:${profile_bio.size}px;
  text-align:center;
}
.socialicon,
.socialicon:hover {
  color: ${icons.color};
  font-size: 24px;
  margin:.5em .3em;
  transition: .25s;
  text-decoration: none;
}
@media only screen and (min-width : 480px) {
.profile_pic {
  min-width:200px;
  width: 250px;
  height: 250px;
  border-radius: 50px;
}
.profile {
  padding: 1.5em 0;
}
.about {
  margin:2em 5em;
  padding:0;
}
.profile-card {
  min-height:100vh;
}
}

@media only screen and (min-width : 1200px) {
.main {
  width: 60%;
  display: flex;
  flex-direction:row;
  justify-content: center;
  align-items: center;
  margin:0 auto;
}
.about {
  margin:3em;
  padding:2em;
  border-left: 2px solid ${about.color};
}
.sml {
  font-size: 24px;
  width: 20px;
  padding:0 10px;
}
heading-h1,
h1 {
  font-size: 3.15em !important;
}
heading-h2,
h2 {
  font-size: 2.25em !important;
}
heading-h3,
h3 {
  font-size: 1.4em !important;
}
}
}
`}</style>
</Helmet>
{(store.getState().activities.edit)         
? <div className="toptoolbar">
	<Tasknav
	onRouteChange={onRouteChange}
	onEdit={onEdit}
	onOpen={onOpen}
	onHighlight={onHighlight}
	highlight={highlight}
	onClickInside={onClickInside}
    onClickOutside={onClickOutside}
	/><span className="navmargin"><br /><br /><br /></span></div>
: null
}
<div className="bg">
{(store.getState().activities.edit)  
? <span onClick={
  (open,select)=>
  {
  if(store.getState().activities.edit && outerdiv) {
  onOpen('cover')
  }
  }}  className="img_edit_cover"><i class="fa fa-camera img_edit_cover_icon" aria-hidden="true"></i> Upload</span>
: null
}
<div className="cover">
</div>
<div className='wrap'>
<div className="main">
<div>
<div className="profile-card"
onMouseOver = {onInnerDiv.bind()}
onMouseOut = {onOuterDiv.bind()}>
<div className="profile">
{(store.getState().activities.edit)  
? <div className="profile_pic">
  <div className="dp select" onClick={(open)=>
  {
  onOpen('propic')
  }}><i class="fa fa-camera img_edit_top_dp" aria-hidden="true"></i><img alt="dp" src={ProPic()} className="dp"/></div>
  </div>
: ProPic() !== null
  ? <div className="profile_pic">
    <img alt="dp" src={ProPic()} className="dp"/>
    </div>
  : null
}
<div className={
	store.getState().activities.edit
	? 'select_col'
	: ''
}>
<Profile onWebsitename={onWebsitename} onWebsiteBio={onWebsiteBio} onHighlight={onHighlight} highlight={highlight} />
<Controller
	onOpen={onOpen}
	onSelectToolbar={onSelectToolbar}
/>
<div className="social_media">
<LinksFunction 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>        
<LinksSection onOpen={onOpen}/>
{(store.getState().activities.edit) 
? <span class="fa fa-plus addnew socialicon" onClick={(open)=>{onOpen('links')}}></span>
: null
}
</div>
</div>
</div>
</div>
</div>
<div className={
  store.getState().activities.edit
  ? 'about select_col'
  : 'about'
}>
<AboutSection/>
</div>
</div>
</div>
</div>
{highlight === 'save'     
? <Save onHighlight={onHighlight} />
: null
}
{(!store.getState().activities.edit)         
?<span className="editbtn" onClick={(edit,open)=>{
onEdit(true)
onOpen(null)
onHighlight(null)
}}>Edit</span>
:<span />
}
{store.getState().activities.open === 'menu'
? <Menu
	onOpen={onOpen}
	onRouteChange={onRouteChange} 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>
: null
}
<CustomizationPanel 
	onEdit={onEdit}
	onOpen={onOpen}
	onSelectToolbar={onSelectToolbar}
	onCustomization={onCustomization}
	onClickInside={onClickInside}
    onClickOutside={onClickOutside} />
<ImageUploadFunction 
	onClickInside={onClickInside}
	onClickOutside={onClickOutside}/>
</div>
  )
}

export default Third